export default __webpack_public_path__ + "3beec707626abc0c47cf90364f8fa5af.webp";